import React, { useState } from 'react';
import { useMessagesStore } from '../../../zustand/store';
import { sendInputFocusStatus } from '../../../utils/utils';
import styles from '../../../style/styles/PreQuestion.module.css';

export const TextInput = ({
  order,
  question,
  fields,
  onAnswer,
  onNext,
}) => {
  const { setMessages } = useMessagesStore();
  const [userInput, setUserInput] = useState('');
  const [inputValid, setInputValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleUserInputChange = (e) => {
    const value = e.target.value;
    setUserInput(value);
    
    // 실시간 검증
    const validationResult = validateInput(value, fields[0].validation);
    setInputValid(validationResult.isValid);
    setErrorMessage(validationResult.isValid ? '' : validationResult.message);
  };

  const validateInput = (value, validation) => {
    const min = fields[0].validation?.min || 1;
    const max = fields[0].validation?.max || 999;
    const numValue = Number(value);
    
    if (!value || value.length === 0) {
      return { isValid: false, message: '값을 입력해주세요' };
    }
    
    if (isNaN(numValue) || numValue < min || numValue > max) {
      return { 
        isValid: false, 
        message: fields[0].warning || `${min}~${max}까지 입력 가능합니다.` 
      };
    }
    
    return { isValid: true };
  };

  const handleButtonClick = () => {
    if (!inputValid) return;
    
    // 메시지에 추가
    setMessages([{ message: question, isChatbot: true }]);
    setMessages([{ message: userInput, isChatbot: false }]);
    
    // 답변 전달
    onAnswer({ key: fields[0].key, answer: userInput }, order);
    
    // 다음 단계로
    onNext();
  };

  const handleKeyPress = (e) => {
    e.stopPropagation();
    if (!inputValid) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      handleButtonClick();
    }
  };

  return (
    <div 
      style={{
        width: '100%', 
        height: 'fit-content', 
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        justifyContent: 'flex-end',
        padding: '10px 16px',
      }}
    >  
      <div 
        style={{
          width: 'fit-content', 
          height: 'fit-content', 
          border: '1px solid #e1e1e1', 
          borderRadius: '10px', 
          padding: '10px', 
          paddingRight: '16px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <label className="h5 fc-gray-600">{fields[0]?.label}</label>
        <div className="spacing-8" />
        <input 
          type="text" 
          className={styles.PreQuestion__input}
          placeholder={fields[0].placeholder}
          value={userInput}
          onChange={handleUserInputChange}
          onKeyDown={handleKeyPress}
          onFocus={() => sendInputFocusStatus(true)}
        />
        {!inputValid && userInput.length > 0 && (
          <>
            <div className='spacing-6' />
            <div className={styles.PreQuestion__warning}>
              <img src='/img/units/cancel.png' alt='cancel' width={16} height={16} />
              <p className='h9 fc-warning'>{errorMessage}</p>
            </div>
          </>
        )}
      </div>
      <button 
        onClick={handleButtonClick}
        className={inputValid ? styles.PreQuestion__submitButton : styles.PreQuestion__submitButton__disabled}
      >
        <p className="h1 fc-white">입력 완료</p>
      </button>
    </div>
  );
};
